
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscribe/confirmed",
      function () {
        return require("private-next-pages/subscribe/confirmed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscribe/confirmed"])
      });
    }
  